import APIService from '@/services/APIService.js';

export default {
  getAll(includeExpiredRecords) {
    return APIService.apiCall().get(`/MontagensAisIncrementais/getAll/${includeExpiredRecords}`);
  },

  getById(id) {
    return APIService.apiCall().get(`/MontagensAisIncrementais/getById/${id}`);
  },

  uploadFile(postData) {
    return APIService.apiCall().post('/MontagensAisIncrementais/upload', postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  salvar(postData) {
    return APIService.apiCall().post('/MontagensAisIncrementais/salvar', JSON.stringify(postData));
  },

  executar(id) {
    return APIService.apiCall().get(`/MontagensAisIncrementais/executar/${id}`);
  },

  getArquivoModelo(config = {}) {
    return APIService.apiCall().get('/MontagensAisIncrementais/baixarArquivoModelo', {
      responseType: 'blob',
      ...config
    });
  },

  downloadResultado(id, config = {}) {
    return APIService.apiCall().get(`/MontagensAisIncrementais/baixarResultado/${id}`, {
      responseType: 'blob',
      ...config
    });
  },

  download(id, config = {}) {
    return this.downloadResultado(id, config);
  },

  baixarRelatorioErros(id, config = {}) {
    return APIService.apiCall().get(`/MontagensAisIncrementais/baixarRelatorioErros/${id}`, {
      responseType: 'blob',
      ...config
    });
  },

  andamento(id) {
    return APIService.apiCall().get(`/MontagensAisIncrementais/andamento/${id}`);
  },

  baixarLogsTecnicos(id, config = {}) {
    return APIService.apiCall().get(`/MontagensAisIncrementais/baixarLogsTecnicos/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
